import cx from 'classnames';

export const getSideContentStylesAsClassName = (align: string): string => {
  return cx('flex items-center leading-10/7 text-primary-main', {
    'max-w-[104px]': align === 'right',
    'max-w-[52px]': align !== 'right',
    'pl-0': align === 'right',
    'pl-4': align !== 'right',
    'pr-4': align === 'right',
  });
};
